module.exports = __webpack_public_path__ + "media/images/web_suite/resources_thumbs/featured-blog-thumbnail-e1c11199b2c74b0290a7e6e3e2d0a36f.png";